import React, { useState, useEffect, useCallback, useMemo } from "react"
import { Button, Popover, Select } from 'antd';
import images from '../../themes/appImage'
import { useNavigate } from "react-router-dom";
import { Table, Modal } from 'antd';
import appconstant from "../../themes/appconstant";
import { useDispatch, useSelector } from "react-redux";
import { reportDataLoad, reportListload } from "../../redux/slices/report.slice";
import { debounce } from "../../utils/global-func";
import moment from "moment";
import { imageURL } from "../../redux/Api/apikit";
import { emptySpaceInputHandler } from "../../utils";



const numberOfRowOptionList = [
    { value: 'one', label: 10 },
    { value: 'two', label: 20 },
    { value: 'three', label: 25 },
]
const listTypeOptions = [
    { value: 'post', label: 'Post' },
    // { value: 'two', label: 'Direct Care	' },
    { value: 'innerCircle', label: 'Inner Circle	' },

]
let currentSortValue = -1
let sort = "createdAt"
let reportType = "post"
const userListPayload = {
    "offset": 0,
    "limit": 10,
    "search": "",
    "sort": sort,
    reportType,
    "order": currentSortValue
}
let LIST_LIMIT = 10;
let OFFSET = 0;
const structureData = (type, data) => {
    if (type == "post") {
        return data.map(item => ({ pic: item.reportedBy?.avatar || "", name: item?.reportedBy?.firstName + item?.reportedBy?.lastName, type: item?.reason, report: reportType, date: moment(item?.createdAt).format('MMMM D, YYYY'), id: item._id }))
    } else {
        return data.map(item => ({ pic: item.reportedBy?.avatar || "", name: item?.reportedBy?.firstName + item?.reportedBy?.lastName, type: "", report: reportType, date: moment(item?.createdAt).format('MMMM D, YYYY'), }))
    }
}
const Reports = () => {
    const dispatch = useDispatch()
    const [modal1Open, setModal1Open] = useState(false);
    const navigate = useNavigate()
    const [search, setSearch] = useState("")
    const { reportData, reportListData } = useSelector(state => state.ReportReducer)
    const listData = useMemo(() => structureData(reportType, reportListData?.list || []), [reportListData.list])
    const reportDataTotalCount = reportData?.circle + reportData?.freezeUser + reportData?.reportedPost + reportData?.reportedUser

    const columns = [{
        title: 'ID',
        dataIndex: 'srno',
        key: 'srno',
        sorter: false,
        render: (value, item, index) => (OFFSET + index + 1)
    },

    {
        title: 'Full Name ',
        dataIndex: 'name',
        key: 'name',
        sorter: false,
        sortDirections: ['ascend', 'descend'],
        title: () => {

            return (
                <div onClick={() => sortHandler("firstName")} className="sort-icons">
                    <span>Full Name</span> <img src={images.arrowLeft} alt="" />
                </div>
            );
        },

        render: (value, item, index) =>
            <div className="organization-image-sec">
                {item.pic && <span><img className="w-6 h-6 rounded-[100%] object-contain" src={`${imageURL}${item.pic}`} /></span>}
                {item.name}
            </div>
    },


    {
        title: 'Problem Type',
        dataIndex: 'type',
        key: 'type',
        sorter: false,
        render: (value, item, index) =>
            <div className="organization-image-sec">
                {item?.type ? item?.type : "N/A"}
            </div>
    },

    {
        title: 'Report Type',
        dataIndex: 'report',
        key: 'report',
        sorter: false,
    },

    {
        title: 'Report Date',
        dataIndex: 'date',
        key: 'date',
        sorter: false,
    },

    {
        title: 'Action',
        dataIndex: 'Posted',
        key: 'Posted',
        render: (value, item, index) => {
            return (

                <Popover
                content={
                  <Button
                    type="text"
                    onClick={() => {
                        navigate('/postreport', {
                            state: {
                                reportType: "post",
                                reportId: item.id
                            }
                        })
                    }}
                  >
                    View
                  </Button>
                }
                trigger="click"
              >
                  <div className="relative action-dots-iocn">
                <span>
                  <img src={images.horizontalDots} />
                </span>
                </div>
              </Popover>
            )
        }
    },
    ];

    useEffect(() => {
        dispatch(reportDataLoad())
        dispatch(reportListload(userListPayload))
    }, [])


    // P A G I N A T I O N 

    // --S T A T E--
    const START = useMemo(() => OFFSET + 1, [reportListData.list]);
    const TOTAL_LIST_ITEMS = useMemo(() => reportListData.pagination?.totalCount, [reportListData.list])
    const END = useMemo(() => (Math.min(OFFSET + LIST_LIMIT, TOTAL_LIST_ITEMS)), [reportListData.list]);
    const canCallNextData = OFFSET + LIST_LIMIT < TOTAL_LIST_ITEMS

    // --A C T I O N S--

    const paginationHandler = useCallback((type) => {
        if (type === "pre") {
            OFFSET = OFFSET - LIST_LIMIT
            const data = {
                offset: OFFSET,
                limit: LIST_LIMIT,
                search: search,
                sort: sort,
                reportType,
                order: currentSortValue
            }
            dispatch(reportListload(data));
        } else {
            OFFSET = OFFSET + LIST_LIMIT
            const data = {
                offset: OFFSET,
                limit: LIST_LIMIT,
                search: search,
                sort: "createdAt",
                reportType,
                order: -1
            }
            dispatch(reportListload(data));
        }
    }, [reportListData.list])

    const numberOfRowHandler = useCallback((ddateStringate, dataObj) => {
        LIST_LIMIT = dataObj.label
        OFFSET = 0
        const data = {
            offset: OFFSET,
            limit: LIST_LIMIT,
            search: search,
            sort: sort,
            reportType,
            order: currentSortValue
        }
        dispatch(reportListload(data));
    }, [reportListData.list])

    const listTypeHandler = useCallback((value) => {
        reportType = value
        const data = {
            offset: 0,
            limit: 10,
            search,
            sort: sort,
            order: currentSortValue,
            reportType: value,
        }
        debounce(() => dispatch(reportListload(data)))
    }, [reportListData.list]);

    const searchHandler = useCallback((e) => {
        if (emptySpaceInputHandler(e) || e.target.value.length == "") {
            LIST_LIMIT = 10
            OFFSET = 0
            setSearch(emptySpaceInputHandler(e))
            const data = {
                offset: 0,
                limit: 10,
                search: emptySpaceInputHandler(e).trim(),
                order: -1,
                reportType
            }
            debounce(() => dispatch(reportListload(data)))
        }
    }, [reportListData.list]);

    const sortHandler = useCallback((sort) => {
        currentSortValue = currentSortValue == -1 ? 1 : -1
        const data = {
            offset: OFFSET,
            limit: LIST_LIMIT,
            search: search,
            sort: sort,
            order: currentSortValue,
            reportType,
        }
        dispatch(reportListload(data));
    }, [reportListData.list])

    return (
        <div>
            <div className="site-layout-background" style={{ minHeight: 360 }}>

                <div className="top-header-organi-zations">
                    <div className="organi-zations-heading-text">
                        <h1>Reports</h1>
                        <p>Sed consectetur imperdiet facilisiulla malesua daeddiet facilisiulla</p>
                    </div>
                    {/* Version 2 */}
                    {/* <div className="add-new-button">
                        <button onClick={() => setModal1Open(true)} >Add Problem Types</button>
                    </div> */}
                </div>

                <div className="total-user reports-page">
                    <div className="user-count number-inner-cricle-ps">
                        <p>Total Reports</p>
                        <h1>{reportDataTotalCount}</h1>
                    </div>

                    <div className="user-count number-inner-cricle-ps">
                        <p>Community Reports</p>
                        <h1>{reportData.reportedPost}</h1>
                    </div>

                    {/* <div onClick={() => { navigate('/directcarereport') }} className="user-count number-inner-cricle-ps">
                        <p>Direct Care Reports</p>
                        <div className="post-active-flex">
                            <h1>100</h1>
                        </div>
                    </div> */}

                    <div onClick={() => { }} className="user-count number-inner-cricle-ps">
                        <p>Inner Circle Reports </p>
                        <div className="post-active-flex">
                            <h1>{reportData.circle}</h1>
                        </div>
                    </div>

                    <div onClick={() => { }} className="user-count number-inner-cricle-ps">
                        <p>User Reports </p>
                        <div className="post-active-flex">
                            <h1>{reportData.reportedUser}</h1>
                        </div>
                    </div>

                    <div className="user-count number-inner-cricle-ps">
                        <p>Frozen Users </p>
                        <div className="post-active-flex">
                            <h1>{reportData.freezeUser}</h1>
                        </div>
                    </div>
                </div>

                <section>
                    <div className="content-e ">
                        <div class="bg-gradient-primary shadow-primary border-radius-lg pt-4 pb-3 system-line">
                            <input type="text" value={search} onChange={searchHandler} className="iocn-search  search-bar" placeholder="Search report" />
                            <div className="top-checkbox">
                                <Select
                                    defaultValue="Post"
                                    onChange={listTypeHandler}
                                    options={listTypeOptions}
                                />
                            </div>
                        </div>

                        <Table
                            dataSource={listData}
                            columns={columns}
                            showSorterTooltip={false}
                            pagination={{
                                current: 0,
                                pageSize: 0,
                                total: TOTAL_LIST_ITEMS,
                            }}
                        />

                        {TOTAL_LIST_ITEMS > 10 && <div className="footer-section">
                            <div className="foot-main-div">
                                <div className="rows">
                                    <div className="row-per-page">
                                        <p>Rows per page</p>
                                    </div>

                                    <div className="top-checkbox fot-select">
                                        <Select
                                            defaultValue={LIST_LIMIT}
                                            onChange={numberOfRowHandler}
                                            options={numberOfRowOptionList}
                                        />
                                    </div>
                                </div>

                                <div className="page-count">
                                    <p>{`${START}-${END} of ${TOTAL_LIST_ITEMS}`}</p>
                                </div>

                                <div className="back-and-next">
                                    {/* <span><img src={images.back} alt="back" /></span> */}
                                    <span onClick={() => OFFSET !== 0 && paginationHandler("pre")}><img src={OFFSET == 0 ? images.per : images.paginationDimLeft} style={{ tintColor: "red" }} alt="back" /></span>
                                    <span onClick={() => canCallNextData && paginationHandler("next")}><img src={canCallNextData == false ? images.paginationDimRight : images.new} alt="back" /></span>
                                    {/* <span><img src={images.next} alt="back" /></span> */}
                                </div>

                            </div>
                        </div>}
                    </div>
                </section>
            </div>

            {/* Add Problem Type */}
            {/* Version 2 */}
            {/* <Modal
                title=""
                className="modal-update"
                centered
                visible={modal1Open}
                closable={true}
                onCancel={() => setModal1Open(false)}
                footer={false}
                width={600}  >
                <div className="add-user-popup">
                    <div className="modal-add-user">
                        <h1>Add Problem Type</h1>
                    </div>
                    <div className="wrapper_line wrapper-space">
                        <div className="form-group">
                            <div className="textarea-label">
                                <label>{appconstant.problemType}</label>
                                <p>0/500</p>
                            </div>
                            <textarea
                                rows="10" cols="50"
                                className='form-control-textarea'
                                type='textarea'
                                placeholder='Add Problem' />
                        </div>
                    </div>
                </div>

                <div className="click-to-upload problem-btn">
                    <div className="create-inner-circle-btn save-btn-mo ">
                        <button>Save</button>
                    </div>
                </div>
            </Modal> */}
        </div>

    )
}
export default Reports

